"use client";

import Link, { LinkProps } from "next/link";
import { ComponentProps, PropsWithChildren } from "react";
import { Link as RadixLink } from "@radix-ui/themes";
import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";

interface Props {
  sharedClasses?: string;
  shopsiteClasses?: string;
  whitelabelClasses?: string;
  href?: LinkProps["href"];
  target?: string;
}

export default function StyledLink({
  className = "",
  sharedClasses = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  children,
  href,
  target,
  asChild,
  ref,
  ...restProps
}: Omit<ComponentProps<typeof RadixLink>, "href"> & PropsWithChildren<Props>) {
  const isShopsite = useIsShopsite();

  const shopsiteBaseClasses = "cursor-pointer";

  if (isShopsite) {
    return href ? (
      <Link
        href={href}
        target={target}
        className={joinClassNames(
          shopsiteBaseClasses,
          className,
          sharedClasses,
          shopsiteClasses
        )}
      >
        {children}
      </Link>
    ) : (
      <span
        className={joinClassNames(
          shopsiteBaseClasses,
          className,
          sharedClasses,
          shopsiteClasses
        )}
      >
        {children}
      </span>
    );
  }

  return (
    <RadixLink
      ref={ref}
      className={joinClassNames(className, sharedClasses, whitelabelClasses)}
      asChild={!!href || asChild}
      {...restProps}
    >
      {href ? (
        <Link href={href} target={target}>
          {children}
        </Link>
      ) : (
        children
      )}
    </RadixLink>
  );
}
